module.exports = __webpack_public_path__ + "static/media/home_news1.94070922.jpg";